export const checklistDocument = {
    addTitleForm: "Ajouter une checklist PDF",
    updateTitleForm: "Remplacer une checklist PDF",
    uploadNewDoc: "Télécharger",
    modifyDoc: "Remplacer"
}